
import React from "react";
import { Lead, Form } from "@/types";
import GlassCard from "@/components/ui/glass-card";
import { motion } from "framer-motion";
import { getInvestmentRange, getExperienceDisplayFromForm } from "@/utils/lead-data-utils";
import { LeadAvatar, LeadCardHeader, LeadCardFooter } from "./lead-card";
import { getFieldData, formatLocation } from "@/utils/lead-formatter-utils";
import { isNewLead, determineLeadStatus } from "@/utils/lead-status-utils";

type LeadCardProps = {
  lead: Lead;
  forms: Form[];
  index: number;
};

const LeadCard = ({ lead, forms, index }: LeadCardProps) => {
  // Extract field data from lead
  const fieldData = getFieldData(lead);
  
  // Format the location display
  const locationDisplay = formatLocation(fieldData.location, lead.data);
  
  // Get investment range
  const investmentRange = getInvestmentRange(lead);
  
  // Get investment experience - still get it but don't pass to the header
  const investmentExperience = getExperienceDisplayFromForm(lead, forms);
  
  // Determine lead status with forms data
  let finalStatus = determineLeadStatus(lead, forms);
  
  // We no longer have the "new" status, so we'll always use the final status
  // If we want to indicate a lead is recent, we can add that separately in the UI
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <GlassCard className="p-4" hover={true} variant="subtle">
        <div className="flex items-start gap-3">
          <LeadAvatar fullName={fieldData.fullName} />
          
          <div className="flex-1 min-w-0 overflow-hidden">
            <LeadCardHeader 
              fullName={fieldData.fullName}
              email={fieldData.email}
              status={finalStatus}
              investmentRange={investmentRange}
              // Removed investment experience prop
            />
            
            <LeadCardFooter 
              createdAt={lead.createdAt}
              locationDisplay={locationDisplay}
            />
          </div>
        </div>
      </GlassCard>
    </motion.div>
  );
};

export default LeadCard;
